import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
import { preserveThemeOnStorageClear } from '@/utils/theme'
import { getToken } from '@/utils/admin'

let handlingExpire = false

function isOAuthRequest(config) {
  if (!config || !config.url) {
    return false
  }
  return String(config.url).includes('/oauth/token')
}

export function handleSessionExpired(message, config) {
  if (isOAuthRequest(config)) {
    return Promise.resolve()
  }
  if (handlingExpire || !getToken()) {
    return Promise.resolve()
  }
  handlingExpire = true

  Message({
    message: message || '登录已过期，请重新登录',
    type: 'warning',
    duration: 3000,
  })

  import('@/utils/websocket/websocket').then(({ offline }) => offline())

  return store.dispatch('logout').then(() => {
    preserveThemeOnStorageClear()
  }).finally(() => {
    const redirect = router.currentRoute.fullPath
    const query = redirect && redirect !== '/login' ? { redirect } : {}
    router.replace({ path: '/login', query }).catch(() => {}).finally(() => {
      setTimeout(() => {
        handlingExpire = false
      }, 500)
    })
  })
}
